
import { useModal } from '@flecto/ui'

import { ModalCustomerSelect, type ModalCustomerSelectProps } from '../components/ModalCustomerSelect/ModalCustomerSelect'

export type UseModalCustomerSelectOptions =
  ModalCustomerSelectProps

export function useModalCustomerSelect(
  props: UseModalCustomerSelectOptions
) {
  return useModal(<ModalCustomerSelect {...props} />)
}
